import type { AreaCatalog } from '../area';
import type { auth as en } from '../en/auth';

export const auth = {
  'auth.form.titleSignUp': 'Konto erstellen',
  'auth.form.titleSignIn': 'Anmelden',
  'auth.form.subtitleInviteOnly':
    'Tesserano ist nur mit Einladung zugänglich. Nutze die Adresse, an die deine Einladung ging.',
  'auth.form.subtitleSignUp': 'Tritt deiner Gruppe auf Tesserano bei.',
  'auth.form.subtitleSignIn': 'Willkommen zurück bei Tesserano.',
  'auth.form.createWith': 'Konto mit {provider} erstellen',
  'auth.form.name': 'Name',
  'auth.form.namePlaceholder': 'Dein Name',
  'auth.form.email': 'E-Mail',
  'auth.form.emailPlaceholder': 'du@example.com',
  'auth.form.code': 'Code',
  'auth.form.password': 'Passwort',
  'auth.form.passwordNewPlaceholder': 'Mindestens 8 Zeichen',
  'auth.form.passwordPlaceholder': 'Dein Passwort',
  'auth.form.resendCode': 'Code erneut senden',
  'auth.form.sendCode': 'Code senden',
  'auth.form.usePassword': 'Stattdessen Passwort nutzen',
  'auth.form.forgotPassword': 'Passwort vergessen?',
  'auth.form.useCode': 'Stattdessen Code per E-Mail senden',
  'auth.form.wait': 'Bitte warten…',
  'auth.form.createAccount': 'Konto erstellen',
  'auth.form.signInWithCode': 'Mit Code anmelden',
  'auth.form.signIn': 'Anmelden',
  'auth.form.or': 'oder',
  'auth.form.continueWith': 'Weiter mit {provider}',
  'auth.form.haveAccount': 'Du hast schon ein Konto? {link}',
  'auth.form.signInLink': 'Anmelden',
  'auth.form.newHere': 'Neu hier? {link}',
  'auth.form.createAccountLink': 'Konto erstellen',
  'auth.form.codeRequested': 'Wenn zu dieser Adresse ein Konto gehört, ist ein Code unterwegs.',
  'auth.error.createAccount': 'Das Konto konnte nicht erstellt werden.',
  'auth.error.code': 'Dieser Code hat nicht funktioniert. Fordere einen neuen an.',
  'auth.error.signIn': 'Die Anmeldung hat nicht geklappt.',
  'auth.error.generic': 'Etwas ist schiefgelaufen. Bitte versuch es noch einmal.',
  'auth.provider.notLinked':
    'Ein Konto nutzt diese Adresse bereits. Melde dich mit deinem Passwort an und verbinde diesen Anmeldedienst dann unter Konto.',
  'auth.provider.accessDenied':
    'Dein Anmeldedienst hat diese Anmeldung abgelehnt. Dein Konto dort hat vielleicht keinen Zugriff auf Tesserano.',
  'auth.provider.signupClosed':
    'Über diesen Anmeldedienst lässt sich hier ohne Einladung kein Konto erstellen.',
  'auth.provider.noAccountFor': 'Noch kein Tesserano-Konto nutzt diese Identität bei {provider}.',
  'auth.provider.noAccount':
    'Noch kein Konto hier nutzt diese Identität. Wenn du eingeladen wurdest, erstelle dein Konto über „Konto erstellen“ mit demselben Anmeldedienst.',
  'auth.provider.failed':
    'Diese Anmeldung hat nicht geklappt. Versuch es noch einmal oder nutze deine E-Mail-Adresse und dein Passwort.',
  'auth.reset.title': 'Passwort zurücksetzen',
  'auth.reset.subtitleRequest': 'Wir senden dir einen Code per E-Mail.',
  'auth.reset.subtitleReset': 'Gib den Code ein und wähle ein neues Passwort.',
  'auth.reset.sendCode': 'Code zum Zurücksetzen senden',
  'auth.reset.code': 'Code zum Zurücksetzen',
  'auth.reset.newPassword': 'Neues Passwort',
  'auth.reset.submit': 'Passwort zurücksetzen',
  'auth.reset.sent':
    'Sieh in deinen E-Mails nach dem Code zum Zurücksetzen (in der Entwicklung steht er in der Serverkonsole).',
  'auth.reset.done': 'Passwort zurückgesetzt. Weiter zur Anmeldung…',
  'auth.reset.sendFailed': 'Der Code zum Zurücksetzen konnte nicht gesendet werden.',
  'auth.reset.noCredential':
    'Dieses Konto hat kein Passwort, das sich zurücksetzen ließe. Melde dich über deinen Anmeldedienst an und lege dann unter Konto ein Passwort fest.',
  'auth.backToSignIn': 'Zurück zur Anmeldung',
  'auth.verify.title': 'E-Mail-Adresse bestätigen',
  'auth.verify.subtitle':
    'Gib den sechsstelligen Code ein, den wir dir geschickt haben (in der Entwicklung steht er in der Serverkonsole).',
  'auth.verify.code': 'Bestätigungscode',
  'auth.verify.submit': 'E-Mail-Adresse bestätigen',
  'auth.verify.didntGetIt': 'Nichts angekommen? {resend}',
  'auth.verify.resend': 'Code erneut senden',
  'auth.verify.emailFirst': 'Gib zuerst deine E-Mail-Adresse ein.',
  'auth.verify.resendFailed': 'Es konnte kein neuer Code gesendet werden.',
  'auth.verify.resent':
    'Ein neuer Code ist unterwegs (in der Entwicklung steht er in der Serverkonsole).',
  'auth.refusal.invalidEmailOrPassword': 'E-Mail-Adresse oder Passwort ist falsch',
  'auth.refusal.invalidPassword': 'Falsches Passwort',
  'auth.refusal.invalidEmail': 'Ungültige E-Mail-Adresse',
  'auth.refusal.userExists': 'Dieses Konto gibt es schon.',
  'auth.refusal.userExistsUseAnother':
    'Dieses Konto gibt es schon. Nimm eine andere E-Mail-Adresse.',
  'auth.refusal.passwordTooShort': 'Das Passwort ist zu kurz',
  'auth.refusal.passwordTooLong': 'Das Passwort ist zu lang',
  'auth.refusal.invalidCode': 'Der Code stimmt nicht',
  'auth.refusal.codeExpired': 'Der Code ist abgelaufen',
  'auth.refusal.tooManyAttempts': 'Zu viele Versuche',
  'auth.refusal.invalidToken': 'Der Link ist ungültig',
  'auth.refusal.tokenExpired': 'Der Link ist abgelaufen',
  'auth.refusal.emailNotVerified': 'Die E-Mail-Adresse ist nicht bestätigt',
  'auth.refusal.sessionExpired': 'Die Sitzung ist abgelaufen. Melde dich neu an, um das zu tun.',
  'auth.refusal.lastAccount': 'Deine letzte Anmeldemöglichkeit kannst du nicht trennen',
  'auth.refusal.socialLinked': 'Dieses Konto ist schon verbunden',
  'auth.refusal.linkedExists': 'Diese Verbindung gibt es schon',
  'auth.refusal.passwordSet': 'Dieses Konto hat schon ein Passwort',
  'auth.refusal.signupClosed': 'Die Registrierung ist geschlossen',
  'auth.refusal.rateLimited': 'Zu viele Anfragen. Bitte versuch es später noch einmal.',
} as const satisfies AreaCatalog<typeof en>;
